// Flash Cards Data - Pure JavaScript (no JSX)
// Separated to avoid babel-metadata-plugin issues

// ============== COMPREHENSIVE FLASH CARDS DATA ==============
// Categories:
// 1. Opening Trades - متى وكيف تفتح صفقة
// 2. Closing Trades - متى وكيف تغلق صفقة  
// 3. Stop Loss & Take Profit - إدارة المخاطر
// 4. Technical Analysis - التحليل الفني
// 5. Trade Management - إدارة الصفقات
// 6. Psychology - السيكولوجية
// 7. Scenarios - سيناريوهات واقعية

export const FLASH_CARDS_DATA = [
  // ============== OPENING TRADES - فتح الصفقات ==============
  {
    id: 1,
    category: { en: "Opening Trades", ar: "فتح الصفقات" },
    question: { 
      en: "What are the 5 conditions to check BEFORE opening any trade?",
      ar: "ما هي الشروط الخمسة التي يجب التحقق منها قبل فتح أي صفقة؟"
    },
    answer: {
      en: `✅ CHECKLIST BEFORE EVERY TRADE:

1️⃣ TREND DIRECTION
   • Is there a clear trend? (Up/Down/Sideways)
   • Never trade against the trend!

2️⃣ INDICATOR CONFIRMATION  
   • Do at least 2-3 indicators agree?
   • RSI + MACD + Price Action

3️⃣ SUPPORT/RESISTANCE
   • Where are the key levels?
   • Am I buying near support or selling near resistance?

4️⃣ RISK MANAGEMENT
   • What's my Stop Loss level?
   • Is Risk:Reward at least 1:2?

5️⃣ NEWS CHECK
   • Any major news coming?
   • Avoid trading during high-impact news!`,
      ar: `✅ قائمة التحقق قبل كل صفقة:

1️⃣ اتجاه السوق
   • هل يوجد اتجاه واضح؟ (صعود/هبوط/عرضي)
   • لا تتداول أبداً عكس الاتجاه!

2️⃣ تأكيد المؤشرات
   • هل توافق 2-3 مؤشرات على الأقل؟
   • RSI + MACD + حركة السعر

3️⃣ الدعم والمقاومة
   • أين المستويات الرئيسية؟
   • هل أشتري قرب الدعم أو أبيع قرب المقاومة؟

4️⃣ إدارة المخاطر
   • ما هو مستوى وقف الخسارة؟
   • هل نسبة المخاطرة:العائد 1:2 على الأقل؟

5️⃣ فحص الأخبار
   • هل هناك أخبار مهمة قادمة؟
   • تجنب التداول وقت الأخبار القوية!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "checklist",
    hasQuiz: true,
    quiz: {
      question: { 
        en: "What's the MINIMUM Risk:Reward ratio you should accept?",
        ar: "ما هو الحد الأدنى لنسبة المخاطرة:العائد التي يجب قبولها؟"
      },
      options: [
        { en: "1:1", ar: "1:1" },
        { en: "1:2", ar: "1:2" },
        { en: "1:0.5", ar: "1:0.5" },
        { en: "2:1", ar: "2:1" }
      ],
      correctIndex: 1,
      explanation: {
        en: "Always aim for at least 1:2 - risk $1 to make $2. This way you profit even with 50% win rate!",
        ar: "استهدف دائماً 1:2 على الأقل - خاطر بـ $1 لتربح $2. بهذه الطريقة تربح حتى مع نسبة نجاح 50%!"
      }
    }
  },
  {
    id: 2,
    category: { en: "Opening Trades", ar: "فتح الصفقات" },
    question: {
      en: "When should you open a BUY trade? (Entry Signals)",
      ar: "متى يجب أن تفتح صفقة شراء؟ (إشارات الدخول)"
    },
    answer: {
      en: `🟢 BUY SIGNALS - When to Enter Long:

📊 RSI SIGNAL:
   • RSI below 30 (Oversold) → BUY
   • RSI crossing up from oversold → Strong BUY

📈 MACD SIGNAL:
   • MACD crosses ABOVE signal line → BUY
   • Histogram turning positive → Momentum building

📉 BOLLINGER BANDS:
   • Price touches lower band → Potential BUY
   • Price bouncing from lower band → Confirm BUY

🎯 SUPPORT/RESISTANCE:
   • Price bouncing from support level → BUY
   • Price breaking above resistance → BUY (breakout)

〰️ MOVING AVERAGES:
   • Price crosses above MA → BUY
   • Golden Cross (MA50 > MA200) → Strong BUY

⚠️ IMPORTANT: Wait for 2-3 confirmations!`,
      ar: `🟢 إشارات الشراء - متى تدخل صفقة شراء:

📊 إشارة RSI:
   • RSI تحت 30 (تشبع بيعي) ← شراء
   • RSI يتقاطع صعوداً من التشبع ← شراء قوي

📈 إشارة MACD:
   • MACD يتقاطع فوق خط الإشارة ← شراء
   • الهيستوجرام يتحول إيجابي ← الزخم يتصاعد

📉 نطاقات بولينجر:
   • السعر يلمس الحد السفلي ← احتمال شراء
   • السعر يرتد من الحد السفلي ← تأكيد شراء

🎯 الدعم والمقاومة:
   • السعر يرتد من مستوى الدعم ← شراء
   • السعر يكسر المقاومة للأعلى ← شراء (اختراق)

〰️ المتوسطات المتحركة:
   • السعر يتقاطع فوق المتوسط ← شراء
   • التقاطع الذهبي (MA50 > MA200) ← شراء قوي

⚠️ مهم: انتظر 2-3 تأكيدات!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "buy"
  },
  {
    id: 3,
    category: { en: "Opening Trades", ar: "فتح الصفقات" },
    question: {
      en: "When should you open a SELL trade? (Entry Signals)",
      ar: "متى يجب أن تفتح صفقة بيع؟ (إشارات الدخول)"
    },
    answer: {
      en: `🔴 SELL SIGNALS - When to Enter Short:

📊 RSI SIGNAL:
   • RSI above 70 (Overbought) → SELL
   • RSI crossing down from overbought → Strong SELL

📈 MACD SIGNAL:
   • MACD crosses BELOW signal line → SELL
   • Histogram turning negative → Momentum fading

📉 BOLLINGER BANDS:
   • Price touches upper band → Potential SELL
   • Price rejecting from upper band → Confirm SELL

🎯 SUPPORT/RESISTANCE:
   • Price rejecting from resistance → SELL
   • Price breaking below support → SELL (breakdown)

〰️ MOVING AVERAGES:
   • Price crosses below MA → SELL
   • Death Cross (MA50 < MA200) → Strong SELL

⚠️ REMEMBER: The trend is your friend!`,
      ar: `🔴 إشارات البيع - متى تدخل صفقة بيع:

📊 إشارة RSI:
   • RSI فوق 70 (تشبع شرائي) ← بيع
   • RSI يتقاطع هبوطاً من التشبع ← بيع قوي

📈 إشارة MACD:
   • MACD يتقاطع تحت خط الإشارة ← بيع
   • الهيستوجرام يتحول سلبي ← الزخم يضعف

📉 نطاقات بولينجر:
   • السعر يلمس الحد العلوي ← احتمال بيع
   • السعر يُرفض من الحد العلوي ← تأكيد بيع

🎯 الدعم والمقاومة:
   • السعر يُرفض من المقاومة ← بيع
   • السعر يكسر الدعم للأسفل ← بيع (انهيار)

〰️ المتوسطات المتحركة:
   • السعر يتقاطع تحت المتوسط ← بيع
   • تقاطع الموت (MA50 < MA200) ← بيع قوي

⚠️ تذكر: الاتجاه صديقك!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "sell"
  },
  {
    id: 4,
    category: { en: "Opening Trades", ar: "فتح الصفقات" },
    question: {
      en: "How to calculate the RIGHT position size for your trade?",
      ar: "كيف تحسب حجم المركز الصحيح لصفقتك؟"
    },
    answer: {
      en: `📐 POSITION SIZE FORMULA:

Position Size = Account Risk ÷ Trade Risk

━━━━━━━━━━━━━━━━━━━━━━
📌 EXAMPLE:
━━━━━━━━━━━━━━━━━━━━━━

Account Balance: $10,000
Risk per trade: 1% = $100
Entry Price: 1.1000
Stop Loss: 1.0950
Trade Risk: 50 pips

Position Size = $100 ÷ 50 pips
Position Size = $2 per pip
Position Size = 0.2 lots (20,000 units)

━━━━━━━━━━━━━━━━━━━━━━
⚠️ GOLDEN RULES:
━━━━━━━━━━━━━━━━━━━━━━
• Never risk more than 1-2% per trade
• Calculate BEFORE entering
• Smaller position = longer survival`,
      ar: `📐 معادلة حجم المركز:

حجم المركز = مخاطرة الحساب ÷ مخاطرة الصفقة

━━━━━━━━━━━━━━━━━━━━━━
📌 مثال:
━━━━━━━━━━━━━━━━━━━━━━

رصيد الحساب: $10,000
المخاطرة لكل صفقة: 1% = $100
سعر الدخول: 1.1000
وقف الخسارة: 1.0950
مخاطرة الصفقة: 50 نقطة

حجم المركز = $100 ÷ 50 نقطة
حجم المركز = $2 لكل نقطة
حجم المركز = 0.2 لوت (20,000 وحدة)

━━━━━━━━━━━━━━━━━━━━━━
⚠️ القواعد الذهبية:
━━━━━━━━━━━━━━━━━━━━━━
• لا تخاطر بأكثر من 1-2% لكل صفقة
• احسب قبل الدخول
• حجم أصغر = بقاء أطول`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "calculator",
    hasQuiz: true,
    quiz: {
      question: {
        en: "Account: $5,000, Risk: 2%, Stop Loss: 25 pips. What's the position size?",
        ar: "الحساب: $5,000، المخاطرة: 2%، وقف الخسارة: 25 نقطة. ما هو حجم المركز؟"
      },
      options: [
        { en: "$2/pip", ar: "$2/نقطة" },
        { en: "$4/pip", ar: "$4/نقطة" },
        { en: "$1/pip", ar: "$1/نقطة" },
        { en: "$5/pip", ar: "$5/نقطة" }
      ],
      correctIndex: 1,
      explanation: {
        en: "$5,000 × 2% = $100 risk. $100 ÷ 25 pips = $4/pip",
        ar: "$5,000 × 2% = $100 مخاطرة. $100 ÷ 25 نقطة = $4/نقطة"
      }
    }
  },

  // ============== CLOSING TRADES - إغلاق الصفقات ==============
  {
    id: 5,
    category: { en: "Closing Trades", ar: "إغلاق الصفقات" },
    question: {
      en: "When should you CLOSE a winning trade? (Exit Strategies)",
      ar: "متى يجب أن تغلق صفقة رابحة؟ (استراتيجيات الخروج)"
    },
    answer: {
      en: `🏆 CLOSING WINNERS - Exit Strategies:

1️⃣ TAKE PROFIT HIT
   • Your pre-set TP level reached
   • ✅ Best method - stick to your plan!

2️⃣ PARTIAL CLOSE
   • Close 50% at TP1, let rest run
   • Move SL to breakeven
   • Lock in profits while catching bigger moves

3️⃣ TRAILING STOP
   • Move SL as price moves in your favor
   • Trail by 10-20 pips or use ATR
   • Let profits run while protecting gains

4️⃣ INDICATOR EXIT
   • RSI reaches opposite extreme (70+ for longs)
   • MACD crosses against you
   • Price hits Bollinger opposite band

5️⃣ TIME-BASED
   • Close before major news
   • Close before weekend
   • Close at end of your trading session

💡 PRO TIP: Never turn a winner into a loser!`,
      ar: `🏆 إغلاق الصفقات الرابحة - استراتيجيات الخروج:

1️⃣ الوصول لهدف الربح
   • وصل السعر لمستوى TP المحدد مسبقاً
   • ✅ أفضل طريقة - التزم بخطتك!

2️⃣ الإغلاق الجزئي
   • أغلق 50% عند TP1، اترك الباقي يجري
   • حرك وقف الخسارة لنقطة التعادل
   • اقفل الأرباح مع إمكانية ربح أكبر

3️⃣ وقف الخسارة المتحرك
   • حرك SL مع تحرك السعر لصالحك
   • تتبع بـ 10-20 نقطة أو استخدم ATR
   • دع الأرباح تجري مع حماية المكاسب

4️⃣ الخروج بالمؤشرات
   • RSI يصل للطرف المعاكس (70+ للشراء)
   • MACD يتقاطع ضدك
   • السعر يصل الحد المعاكس لبولينجر

5️⃣ الخروج الزمني
   • أغلق قبل الأخبار المهمة
   • أغلق قبل نهاية الأسبوع
   • أغلق في نهاية جلسة التداول

💡 نصيحة: لا تحول الرابح إلى خاسر أبداً!`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "profit"
  },
  {
    id: 6,
    category: { en: "Closing Trades", ar: "إغلاق الصفقات" },
    question: {
      en: "When should you CLOSE a losing trade? (Cutting Losses)",
      ar: "متى يجب أن تغلق صفقة خاسرة؟ (قطع الخسائر)"
    },
    answer: {
      en: `🛑 CLOSING LOSERS - When to Cut:

1️⃣ STOP LOSS HIT ⭐
   • Your pre-set SL is triggered
   • ✅ BEST method - accept and move on
   • ❌ NEVER move SL further away!

2️⃣ INVALIDATION
   • Your trade reason is no longer valid
   • Example: You bought at support, support broke
   • Exit immediately - don't wait for SL

3️⃣ TIME STOP
   • Trade not moving after X hours/days
   • Capital tied up = opportunity cost
   • Close and find better setup

4️⃣ REVERSAL SIGNALS
   • Strong opposite signal appears
   • Major news against your position
   • Close early to minimize loss

━━━━━━━━━━━━━━━━━━━━━━
⚠️ MISTAKES TO AVOID:
━━━━━━━━━━━━━━━━━━━━━━
❌ Moving SL to avoid loss
❌ Averaging down on losers
❌ Hoping price will return
❌ Removing SL completely`,
      ar: `🛑 إغلاق الخاسرة - متى تقطع:

1️⃣ تفعيل وقف الخسارة ⭐
   • تم تفعيل SL المحدد مسبقاً
   • ✅ أفضل طريقة - تقبل وانتقل
   • ❌ لا تحرك SL أبداً للأبعد!

2️⃣ إبطال السبب
   • سبب صفقتك لم يعد صالحاً
   • مثال: اشتريت عند الدعم، الدعم انكسر
   • اخرج فوراً - لا تنتظر SL

3️⃣ التوقف الزمني
   • الصفقة لم تتحرك بعد X ساعات/أيام
   • رأس المال مقيد = تكلفة فرصة
   • أغلق وابحث عن فرصة أفضل

4️⃣ إشارات انعكاس
   • ظهور إشارة معاكسة قوية
   • أخبار كبيرة ضد مركزك
   • أغلق مبكراً لتقليل الخسارة

━━━━━━━━━━━━━━━━━━━━━━
⚠️ أخطاء يجب تجنبها:
━━━━━━━━━━━━━━━━━━━━━━
❌ تحريك SL لتجنب الخسارة
❌ المضاعفة على الخاسر
❌ الأمل بعودة السعر
❌ إزالة وقف الخسارة كلياً`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "stop",
    hasQuiz: true,
    quiz: {
      question: {
        en: "Your BUY trade is losing. The support you bought at just broke. What should you do?",
        ar: "صفقة الشراء خاسرة. الدعم الذي اشتريت عنده انكسر للتو. ماذا يجب أن تفعل؟"
      },
      options: [
        { en: "Wait for SL", ar: "انتظر وقف الخسارة" },
        { en: "Exit immediately", ar: "اخرج فوراً" },
        { en: "Move SL lower", ar: "حرك SL للأسفل" },
        { en: "Add more to average down", ar: "أضف المزيد للمعدل" }
      ],
      correctIndex: 1,
      explanation: {
        en: "Exit immediately! Your trade reason (support) is invalidated. Don't wait to lose more.",
        ar: "اخرج فوراً! سبب صفقتك (الدعم) أُبطل. لا تنتظر لتخسر أكثر."
      }
    }
  },
  {
    id: 7,
    category: { en: "Closing Trades", ar: "إغلاق الصفقات" },
    question: {
      en: "How to use TRAILING STOP to maximize profits?",
      ar: "كيف تستخدم وقف الخسارة المتحرك لتعظيم الأرباح؟"
    },
    answer: {
      en: `📈 TRAILING STOP METHODS:

1️⃣ FIXED PIPS TRAIL
   • Move SL up by 10-20 pips as price moves
   • Example: Entry 1.1000, price at 1.1050
   • Move SL from 1.0950 to 1.1000 (breakeven)

2️⃣ ATR-BASED TRAIL
   • Use ATR × 1.5 or 2 for trail distance
   • More adaptive to market volatility
   • Wider in volatile, tighter in calm markets

3️⃣ STRUCTURE-BASED TRAIL
   • Move SL below each new higher low (uptrend)
   • Move SL above each new lower high (downtrend)
   • ✅ Best method - respects market structure

4️⃣ MOVING AVERAGE TRAIL
   • Use MA as trailing stop
   • Close when price crosses MA against you
   • Good for trending markets

━━━━━━━━━━━━━━━━━━━━━━
📌 EXAMPLE TRADE:
━━━━━━━━━━━━━━━━━━━━━━
Entry: 1.1000 | Initial SL: 1.0960

Price moves to 1.1040:
→ Move SL to 1.1000 (breakeven)

Price moves to 1.1080:
→ Move SL to 1.1040 (lock 40 pips)

Price reverses, hits SL at 1.1040:
→ Profit: +40 pips ✅`,
      ar: `📈 طرق وقف الخسارة المتحرك:

1️⃣ التتبع بالنقاط الثابتة
   • حرك SL بـ 10-20 نقطة مع تحرك السعر
   • مثال: الدخول 1.1000، السعر عند 1.1050
   • حرك SL من 1.0950 إلى 1.1000 (تعادل)

2️⃣ التتبع بـ ATR
   • استخدم ATR × 1.5 أو 2 لمسافة التتبع
   • أكثر تكيفاً مع تقلبات السوق
   • أوسع في التقلب، أضيق في الهدوء

3️⃣ التتبع الهيكلي
   • حرك SL تحت كل قاع أعلى جديد (صعود)
   • حرك SL فوق كل قمة أدنى جديدة (هبوط)
   • ✅ أفضل طريقة - تحترم هيكل السوق

4️⃣ التتبع بالمتوسط المتحرك
   • استخدم MA كوقف متحرك
   • أغلق عند تقاطع السعر للمتوسط ضدك
   • جيد للأسواق الاتجاهية

━━━━━━━━━━━━━━━━━━━━━━
📌 مثال صفقة:
━━━━━━━━━━━━━━━━━━━━━━
الدخول: 1.1000 | SL الأولي: 1.0960

السعر يتحرك إلى 1.1040:
← حرك SL إلى 1.1000 (تعادل)

السعر يتحرك إلى 1.1080:
← حرك SL إلى 1.1040 (اقفل 40 نقطة)

السعر ينعكس، يضرب SL عند 1.1040:
← الربح: +40 نقطة ✅`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "trending"
  },

  // ============== STOP LOSS & TAKE PROFIT ==============
  {
    id: 8,
    category: { en: "Stop Loss & Take Profit", ar: "وقف الخسارة وجني الأرباح" },
    question: {
      en: "Where to place your STOP LOSS? (SL Placement)",
      ar: "أين تضع وقف الخسارة؟ (تحديد موقع SL)"
    },
    answer: {
      en: `🛡️ STOP LOSS PLACEMENT RULES:

FOR BUY TRADES:
━━━━━━━━━━━━━━━━━━━━━━
✅ Below recent swing low
✅ Below support level + buffer
✅ Below Bollinger lower band
✅ Below moving average (MA20/50)

FOR SELL TRADES:
━━━━━━━━━━━━━━━━━━━━━━
✅ Above recent swing high
✅ Above resistance level + buffer
✅ Above Bollinger upper band
✅ Above moving average (MA20/50)

📐 BUFFER CALCULATION:
• Add 5-10 pips to avoid stop hunts
• Or use ATR: Level ± (ATR × 0.5)

━━━━━━━━━━━━━━━━━━━━━━
❌ WRONG SL PLACEMENT:
━━━━━━━━━━━━━━━━━━━━━━
• Exactly on support/resistance (will get hit)
• Random number of pips
• Too tight (normal volatility will hit it)
• Too wide (risk too much)`,
      ar: `🛡️ قواعد وضع وقف الخسارة:

لصفقات الشراء:
━━━━━━━━━━━━━━━━━━━━━━
✅ تحت آخر قاع متأرجح
✅ تحت مستوى الدعم + هامش
✅ تحت الحد السفلي لبولينجر
✅ تحت المتوسط المتحرك (MA20/50)

لصفقات البيع:
━━━━━━━━━━━━━━━━━━━━━━
✅ فوق آخر قمة متأرجحة
✅ فوق مستوى المقاومة + هامش
✅ فوق الحد العلوي لبولينجر
✅ فوق المتوسط المتحرك (MA20/50)

📐 حساب الهامش:
• أضف 5-10 نقاط لتجنب الصيد
• أو استخدم ATR: المستوى ± (ATR × 0.5)

━━━━━━━━━━━━━━━━━━━━━━
❌ وضع SL خاطئ:
━━━━━━━━━━━━━━━━━━━━━━
• بالضبط على الدعم/المقاومة (سيُضرب)
• عدد عشوائي من النقاط
• ضيق جداً (التقلب الطبيعي سيضربه)
• واسع جداً (مخاطرة كبيرة)`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "shield"
  },
  {
    id: 9,
    category: { en: "Stop Loss & Take Profit", ar: "وقف الخسارة وجني الأرباح" },
    question: {
      en: "Where to place your TAKE PROFIT? (TP Placement)",
      ar: "أين تضع هدف الربح؟ (تحديد موقع TP)"
    },
    answer: {
      en: `🎯 TAKE PROFIT PLACEMENT:

METHOD 1: RISK:REWARD RATIO
━━━━━━━━━━━━━━━━━━━━━━
• TP1 = 1:1 (same as SL distance)
• TP2 = 1:2 (2× SL distance)
• TP3 = 1:3 (3× SL distance)

METHOD 2: TECHNICAL LEVELS
━━━━━━━━━━━━━━━━━━━━━━
FOR BUY:
• Next resistance level
• Previous swing high
• Bollinger upper band

FOR SELL:
• Next support level
• Previous swing low
• Bollinger lower band

METHOD 3: FIBONACCI
━━━━━━━━━━━━━━━━━━━━━━
• 161.8% extension for TP1
• 261.8% extension for TP2

📌 MULTIPLE TP STRATEGY:
• TP1: Close 50% at 1:1
• TP2: Close 30% at 1:2
• TP3: Let 20% run with trail`,
      ar: `🎯 وضع هدف الربح:

الطريقة 1: نسبة المخاطرة:العائد
━━━━━━━━━━━━━━━━━━━━━━
• TP1 = 1:1 (نفس مسافة SL)
• TP2 = 1:2 (2× مسافة SL)
• TP3 = 1:3 (3× مسافة SL)

الطريقة 2: المستويات الفنية
━━━━━━━━━━━━━━━━━━━━━━
للشراء:
• مستوى المقاومة التالي
• القمة المتأرجحة السابقة
• الحد العلوي لبولينجر

للبيع:
• مستوى الدعم التالي
• القاع المتأرجح السابق
• الحد السفلي لبولينجر

الطريقة 3: فيبوناتشي
━━━━━━━━━━━━━━━━━━━━━━
• امتداد 161.8% لـ TP1
• امتداد 261.8% لـ TP2

📌 استراتيجية TP المتعددة:
• TP1: أغلق 50% عند 1:1
• TP2: أغلق 30% عند 1:2
• TP3: اترك 20% تجري مع التتبع`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "target"
  },
  {
    id: 10,
    category: { en: "Stop Loss & Take Profit", ar: "وقف الخسارة وجني الأرباح" },
    question: {
      en: "What is the 1% Risk Rule and why is it CRITICAL?",
      ar: "ما هي قاعدة 1% للمخاطرة ولماذا هي حاسمة؟"
    },
    answer: {
      en: `💰 THE 1% RULE - Your Survival Guide:

RULE: Never risk more than 1% of your account on a single trade.

━━━━━━━━━━━━━━━━━━━━━━
📊 WHY IT MATTERS:
━━━━━━━━━━━━━━━━━━━━━━

10 losing trades in a row:
• With 1% risk: Account down 10%
• With 5% risk: Account down 50%
• With 10% risk: Account WIPED

━━━━━━━━━━━━━━━━━━━━━━
📈 RECOVERY MATH:
━━━━━━━━━━━━━━━━━━━━━━
Lose 10% → Need 11% to recover
Lose 20% → Need 25% to recover
Lose 50% → Need 100% to recover!

━━━━━━━━━━━━━━━━━━━━━━
✅ PRACTICAL EXAMPLE:
━━━━━━━━━━━━━━━━━━━━━━
Account: $10,000
Max risk per trade: $100 (1%)
Stop Loss: 50 pips
Position size: $2/pip

You can lose 100 trades before wiping out!
But with 5% risk, only 20 trades!`,
      ar: `💰 قاعدة 1% - دليل بقائك:

القاعدة: لا تخاطر بأكثر من 1% من حسابك في صفقة واحدة.

━━━━━━━━━━━━━━━━━━━━━━
📊 لماذا هي مهمة:
━━━━━━━━━━━━━━━━━━━━━━

10 صفقات خاسرة متتالية:
• مع 1% مخاطرة: الحساب ينخفض 10%
• مع 5% مخاطرة: الحساب ينخفض 50%
• مع 10% مخاطرة: الحساب يُمحى

━━━━━━━━━━━━━━━━━━━━━━
📈 رياضيات التعافي:
━━━━━━━━━━━━━━━━━━━━━━
خسارة 10% ← تحتاج 11% للتعافي
خسارة 20% ← تحتاج 25% للتعافي
خسارة 50% ← تحتاج 100% للتعافي!

━━━━━━━━━━━━━━━━━━━━━━
✅ مثال عملي:
━━━━━━━━━━━━━━━━━━━━━━
الحساب: $10,000
أقصى مخاطرة لكل صفقة: $100 (1%)
وقف الخسارة: 50 نقطة
حجم المركز: $2/نقطة

يمكنك خسارة 100 صفقة قبل المحو!
لكن مع 5% مخاطرة، 20 صفقة فقط!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "alert",
    hasQuiz: true,
    quiz: {
      question: {
        en: "You lost 50% of your account. How much do you need to gain to recover?",
        ar: "خسرت 50% من حسابك. كم تحتاج أن تربح للتعافي؟"
      },
      options: [
        { en: "50%", ar: "50%" },
        { en: "75%", ar: "75%" },
        { en: "100%", ar: "100%" },
        { en: "150%", ar: "150%" }
      ],
      correctIndex: 2,
      explanation: {
        en: "If you have $5,000 left (50% loss), you need to make $5,000 which is 100% of $5,000 to get back to $10,000!",
        ar: "إذا بقي لديك $5,000 (خسارة 50%)، تحتاج لربح $5,000 وهو 100% من $5,000 للعودة إلى $10,000!"
      }
    }
  },

  // ============== SCENARIOS - سيناريوهات واقعية ==============
  {
    id: 11,
    category: { en: "Real Scenarios", ar: "سيناريوهات واقعية" },
    question: {
      en: "SCENARIO: RSI is at 25, Price at Support. What do you do?",
      ar: "سيناريو: RSI عند 25، السعر عند الدعم. ماذا تفعل؟"
    },
    answer: {
      en: `📊 SCENARIO ANALYSIS:

GIVEN:
• RSI = 25 (Oversold ✅)
• Price at support level ✅

━━━━━━━━━━━━━━━━━━━━━━
🔍 ANALYSIS:
━━━━━━━━━━━━━━━━━━━━━━
✅ RSI oversold = Potential BUY signal
✅ Price at support = Good entry point
⚠️ Need more confirmation!

━━━━━━━━━━━━━━━━━━━━━━
📋 ACTION PLAN:
━━━━━━━━━━━━━━━━━━━━━━
1. Check MACD - Is it turning bullish?
2. Check trend - Is the overall trend up?
3. Look for bullish candle pattern
4. If yes to 2+ above → ENTER BUY

📌 TRADE SETUP:
• Entry: At support + confirmation candle
• Stop Loss: Below support - 10 pips
• Take Profit: Next resistance or 1:2 ratio

⚠️ DON'T: Buy blindly just because RSI is low!
The trend might be strongly bearish.`,
      ar: `📊 تحليل السيناريو:

المعطيات:
• RSI = 25 (تشبع بيعي ✅)
• السعر عند مستوى الدعم ✅

━━━━━━━━━━━━━━━━━━━━━━
🔍 التحليل:
━━━━━━━━━━━━━━━━━━━━━━
✅ RSI في تشبع بيعي = إشارة شراء محتملة
✅ السعر عند الدعم = نقطة دخول جيدة
⚠️ نحتاج المزيد من التأكيد!

━━━━━━━━━━━━━━━━━━━━━━
📋 خطة العمل:
━━━━━━━━━━━━━━━━━━━━━━
1. تحقق من MACD - هل يتحول صعودياً؟
2. تحقق من الاتجاه - هل الاتجاه العام صعودي؟
3. ابحث عن نمط شمعة صعودي
4. إذا نعم لـ 2+ مما سبق ← ادخل شراء

📌 إعداد الصفقة:
• الدخول: عند الدعم + شمعة تأكيد
• وقف الخسارة: تحت الدعم - 10 نقاط
• هدف الربح: المقاومة التالية أو نسبة 1:2

⚠️ لا تفعل: لا تشتري بشكل أعمى لأن RSI منخفض!
قد يكون الاتجاه هبوطياً بقوة.`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "scenario"
  },
  {
    id: 12,
    category: { en: "Real Scenarios", ar: "سيناريوهات واقعية" },
    question: {
      en: "SCENARIO: Your trade is +50 pips profit. What now?",
      ar: "سيناريو: صفقتك في ربح +50 نقطة. ماذا الآن؟"
    },
    answer: {
      en: `💰 MANAGING A WINNING TRADE:

SITUATION:
• Entry: 1.1000
• Current: 1.1050 (+50 pips)
• Original SL: 1.0970 (30 pips)
• Original TP: 1.1090 (90 pips)

━━━━━━━━━━━━━━━━━━━━━━
📋 OPTIONS:
━━━━━━━━━━━━━━━━━━━━━━

OPTION 1: MOVE SL TO BREAKEVEN ⭐
• New SL: 1.1000 (entry price)
• Risk: $0 | Potential: +40 pips
• ✅ Recommended for beginners

OPTION 2: PARTIAL CLOSE
• Close 50% now (+25 pips locked)
• Move SL to breakeven
• Let rest run to TP

OPTION 3: TRAIL STOP
• Move SL to 1.1020 (+20 pips locked)
• Continue trailing as price moves
• Maximum profit potential

OPTION 4: CLOSE ALL
• Take the +50 pips now
• Good if near resistance or news coming

⚠️ NEVER: Let a +50 pip winner turn into a loss!`,
      ar: `💰 إدارة صفقة رابحة:

الوضع:
• الدخول: 1.1000
• الحالي: 1.1050 (+50 نقطة)
• SL الأصلي: 1.0970 (30 نقطة)
• TP الأصلي: 1.1090 (90 نقطة)

━━━━━━━━━━━━━━━━━━━━━━
📋 الخيارات:
━━━━━━━━━━━━━━━━━━━━━━

الخيار 1: حرك SL للتعادل ⭐
• SL الجديد: 1.1000 (سعر الدخول)
• المخاطرة: $0 | الإمكانية: +40 نقطة
• ✅ موصى به للمبتدئين

الخيار 2: إغلاق جزئي
• أغلق 50% الآن (+25 نقطة مقفلة)
• حرك SL للتعادل
• اترك الباقي يجري للـ TP

الخيار 3: التتبع
• حرك SL إلى 1.1020 (+20 نقطة مقفلة)
• استمر بالتتبع مع تحرك السعر
• أقصى إمكانية ربح

الخيار 4: إغلاق الكل
• خذ +50 نقطة الآن
• جيد إذا قرب مقاومة أو أخبار قادمة

⚠️ أبداً: لا تدع رابح +50 نقطة يتحول لخاسر!`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "profit",
    hasQuiz: true,
    quiz: {
      question: {
        en: "Your trade is +50 pips. Price is approaching major resistance. What's SAFEST?",
        ar: "صفقتك +50 نقطة. السعر يقترب من مقاومة رئيسية. ما هو الأكثر أماناً؟"
      },
      options: [
        { en: "Hold and hope for breakout", ar: "انتظر وتمنى الاختراق" },
        { en: "Close 50-100% of position", ar: "أغلق 50-100% من المركز" },
        { en: "Add more to the position", ar: "أضف المزيد للمركز" },
        { en: "Remove stop loss", ar: "أزل وقف الخسارة" }
      ],
      correctIndex: 1,
      explanation: {
        en: "At major resistance, safest is to take profits (full or partial). Resistance often causes reversals!",
        ar: "عند مقاومة رئيسية، الأكثر أماناً أخذ الأرباح (كلياً أو جزئياً). المقاومة غالباً تسبب انعكاسات!"
      }
    }
  },
  {
    id: 13,
    category: { en: "Real Scenarios", ar: "سيناريوهات واقعية" },
    question: {
      en: "SCENARIO: You just had 3 losing trades in a row. What do you do?",
      ar: "سيناريو: خسرت 3 صفقات متتالية للتو. ماذا تفعل؟"
    },
    answer: {
      en: `😤 HANDLING A LOSING STREAK:

❌ WHAT NOT TO DO:
━━━━━━━━━━━━━━━━━━━━━━
• Revenge trade (bigger position)
• Trade without analysis
• Try to "make it back quick"
• Abandon your strategy
• Trade while emotional

✅ WHAT TO DO:
━━━━━━━━━━━━━━━━━━━━━━

1️⃣ STOP TRADING
   • Step away from the screen
   • Take a break (30 min - 1 day)
   • Clear your mind

2️⃣ REVIEW YOUR TRADES
   • Were they according to your plan?
   • What went wrong?
   • Was it bad luck or bad execution?

3️⃣ REDUCE SIZE
   • Cut position size by 50%
   • Rebuild confidence with smaller risk

4️⃣ WAIT FOR A+ SETUPS ONLY
   • Be extra selective
   • Only take perfect setups
   • Quality over quantity

5️⃣ JOURNAL IT
   • Write what happened
   • Write how you feel
   • Plan your next steps

💡 REMEMBER: 3 losses with 1% risk = only 3% loss
This is NORMAL. It's not the end!`,
      ar: `😤 التعامل مع سلسلة الخسائر:

❌ ما لا يجب فعله:
━━━━━━━━━━━━━━━━━━━━━━
• التداول الانتقامي (حجم أكبر)
• التداول بدون تحليل
• محاولة "استرجاعها بسرعة"
• التخلي عن استراتيجيتك
• التداول وأنت عاطفي

✅ ما يجب فعله:
━━━━━━━━━━━━━━━━━━━━━━

1️⃣ توقف عن التداول
   • ابتعد عن الشاشة
   • خذ استراحة (30 دقيقة - يوم)
   • صفِّ ذهنك

2️⃣ راجع صفقاتك
   • هل كانت وفق خطتك؟
   • ما الذي أخطأ؟
   • هل كان سوء حظ أم تنفيذ سيء؟

3️⃣ قلل الحجم
   • اقطع حجم المركز بـ 50%
   • أعد بناء الثقة بمخاطرة أقل

4️⃣ انتظر فقط الفرص المثالية
   • كن أكثر انتقائية
   • خذ فقط الإعدادات المثالية
   • الجودة فوق الكمية

5️⃣ سجّل في دفترك
   • اكتب ما حدث
   • اكتب كيف تشعر
   • خطط لخطواتك القادمة

💡 تذكر: 3 خسائر بـ 1% مخاطرة = 3% خسارة فقط
هذا طبيعي. ليست النهاية!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "psychology"
  },

  // ============== TECHNICAL ANALYSIS - التحليل الفني ==============
  {
    id: 14,
    category: { en: "Technical Analysis", ar: "التحليل الفني" },
    question: {
      en: "How to identify a STRONG trend vs WEAK trend?",
      ar: "كيف تحدد الاتجاه القوي من الاتجاه الضعيف؟"
    },
    answer: {
      en: `📈 TREND STRENGTH ANALYSIS:

STRONG UPTREND ✅:
━━━━━━━━━━━━━━━━━━━━━━
• Higher highs AND higher lows
• Price above MA20 and MA50
• MA20 above MA50
• ADX > 25
• Strong bullish candles
• High volume on up moves

WEAK UPTREND ⚠️:
━━━━━━━━━━━━━━━━━━━━━━
• Higher highs but shallow pullbacks
• Price near MA20/50
• ADX < 20
• Small candles, indecision
• Decreasing volume

STRONG DOWNTREND ✅:
━━━━━━━━━━━━━━━━━━━━━━
• Lower lows AND lower highs
• Price below MA20 and MA50
• MA20 below MA50
• ADX > 25
• Strong bearish candles

NO TREND (RANGING) ⚠️:
━━━━━━━━━━━━━━━━━━━━━━
• Price bouncing between S/R
• ADX < 20
• MAs flat and intertwined
• Trade: Buy at support, Sell at resistance`,
      ar: `📈 تحليل قوة الاتجاه:

اتجاه صعودي قوي ✅:
━━━━━━━━━━━━━━━━━━━━━━
• قمم أعلى وقيعان أعلى
• السعر فوق MA20 و MA50
• MA20 فوق MA50
• ADX > 25
• شموع صعودية قوية
• حجم عالي في الصعود

اتجاه صعودي ضعيف ⚠️:
━━━━━━━━━━━━━━━━━━━━━━
• قمم أعلى لكن تراجعات ضحلة
• السعر قرب MA20/50
• ADX < 20
• شموع صغيرة، تردد
• حجم متناقص

اتجاه هبوطي قوي ✅:
━━━━━━━━━━━━━━━━━━━━━━
• قيعان أدنى وقمم أدنى
• السعر تحت MA20 و MA50
• MA20 تحت MA50
• ADX > 25
• شموع هبوطية قوية

لا اتجاه (عرضي) ⚠️:
━━━━━━━━━━━━━━━━━━━━━━
• السعر يرتد بين الدعم/المقاومة
• ADX < 20
• المتوسطات مسطحة ومتشابكة
• تداول: اشترِ عند الدعم، بع عند المقاومة`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "trending"
  },
  {
    id: 15,
    category: { en: "Technical Analysis", ar: "التحليل الفني" },
    question: {
      en: "What are the BEST indicator combinations?",
      ar: "ما هي أفضل توليفات المؤشرات؟"
    },
    answer: {
      en: `🔧 WINNING INDICATOR COMBOS:

COMBO 1: TREND + MOMENTUM ⭐
━━━━━━━━━━━━━━━━━━━━━━
• MA (20/50) for trend
• RSI for momentum/reversals
• Use: Trade WITH trend when RSI confirms

COMBO 2: TRIPLE CONFIRMATION
━━━━━━━━━━━━━━━━━━━━━━
• MACD for trend/momentum
• RSI for overbought/oversold
• Support/Resistance for entry
• Use: All 3 must agree!

COMBO 3: VOLATILITY + TREND
━━━━━━━━━━━━━━━━━━━━━━
• Bollinger Bands for volatility
• ADX for trend strength
• Use: Trade bands in low ADX, trend in high ADX

COMBO 4: COMPLETE SYSTEM
━━━━━━━━━━━━━━━━━━━━━━
• ADX for trend strength
• RSI for timing
• S/R for entry/exit levels
• ATR for stop loss distance

━━━━━━━━━━━━━━━━━━━━━━
⚠️ AVOID:
━━━━━━━━━━━━━━━━━━━━━━
• Using too many indicators (max 3-4)
• Using same-type indicators (RSI + Stochastic)
• Ignoring price action`,
      ar: `🔧 توليفات المؤشرات الرابحة:

التوليفة 1: اتجاه + زخم ⭐
━━━━━━━━━━━━━━━━━━━━━━
• MA (20/50) للاتجاه
• RSI للزخم/الانعكاسات
• استخدم: تداول مع الاتجاه عند تأكيد RSI

التوليفة 2: التأكيد الثلاثي
━━━━━━━━━━━━━━━━━━━━━━
• MACD للاتجاه/الزخم
• RSI للتشبع
• الدعم/المقاومة للدخول
• استخدم: الثلاثة يجب أن يتفقوا!

التوليفة 3: التقلب + الاتجاه
━━━━━━━━━━━━━━━━━━━━━━
• بولينجر للتقلب
• ADX لقوة الاتجاه
• استخدم: تداول النطاقات في ADX منخفض، الاتجاه في ADX عالي

التوليفة 4: النظام الكامل
━━━━━━━━━━━━━━━━━━━━━━
• ADX لقوة الاتجاه
• RSI للتوقيت
• الدعم/المقاومة لمستويات الدخول/الخروج
• ATR لمسافة وقف الخسارة

━━━━━━━━━━━━━━━━━━━━━━
⚠️ تجنب:
━━━━━━━━━━━━━━━━━━━━━━
• استخدام مؤشرات كثيرة (أقصى 3-4)
• استخدام نفس نوع المؤشرات (RSI + ستوكاستيك)
• تجاهل حركة السعر`
    },
    difficulty: { en: "Intermediate", ar: "متوسط" },
    icon: "settings"
  },

  // ============== TRADING PSYCHOLOGY - السيكولوجية ==============
  {
    id: 16,
    category: { en: "Trading Psychology", ar: "سيكولوجية التداول" },
    question: {
      en: "The 10 RULES of Successful Traders",
      ar: "القواعد العشر للمتداولين الناجحين"
    },
    answer: {
      en: `🏆 10 RULES OF SUCCESSFUL TRADERS:

1️⃣ PLAN YOUR TRADE, TRADE YOUR PLAN
   • Never enter without a clear plan
   
2️⃣ USE STOP LOSS - ALWAYS
   • No exceptions. Ever.
   
3️⃣ RISK 1% OR LESS
   • Survival > Big wins
   
4️⃣ CUT LOSERS FAST
   • Small losses are okay
   
5️⃣ LET WINNERS RUN
   • Don't close too early
   
6️⃣ NO REVENGE TRADING
   • Losses happen. Accept it.
   
7️⃣ BE PATIENT
   • Wait for the RIGHT setup
   
8️⃣ KEEP A JOURNAL
   • Review and improve
   
9️⃣ CONTROL EMOTIONS
   • Trade logic, not feelings
   
🔟 CONTINUOUS LEARNING
   • Markets evolve. So should you.

💎 BONUS: Consistency beats perfection!`,
      ar: `🏆 القواعد العشر للمتداولين الناجحين:

1️⃣ خطط صفقتك، تداول خطتك
   • لا تدخل أبداً بدون خطة واضحة
   
2️⃣ استخدم وقف الخسارة - دائماً
   • لا استثناءات. أبداً.
   
3️⃣ خاطر بـ 1% أو أقل
   • البقاء > المكاسب الكبيرة
   
4️⃣ اقطع الخاسرين بسرعة
   • الخسائر الصغيرة مقبولة
   
5️⃣ دع الرابحين يجرون
   • لا تغلق مبكراً جداً
   
6️⃣ لا تداول انتقامي
   • الخسائر تحدث. تقبّلها.
   
7️⃣ كن صبوراً
   • انتظر الفرصة الصحيحة
   
8️⃣ احتفظ بدفتر تداول
   • راجع وتحسّن
   
9️⃣ تحكم بالعواطف
   • تداول بالمنطق لا المشاعر
   
🔟 التعلم المستمر
   • الأسواق تتطور. وأنت أيضاً.

💎 مكافأة: الاستمرارية تتفوق على الكمال!`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "trophy"
  },
  {
    id: 17,
    category: { en: "Trading Psychology", ar: "سيكولوجية التداول" },
    question: {
      en: "How to build a TRADING PLAN that works?",
      ar: "كيف تبني خطة تداول ناجحة؟"
    },
    answer: {
      en: `📋 YOUR TRADING PLAN TEMPLATE:

1️⃣ MARKETS
   • Which pairs/assets will you trade?
   • Example: EUR/USD, Gold, Bitcoin only

2️⃣ TIMEFRAMES
   • Which timeframes for analysis?
   • Example: 4H for trend, 1H for entry

3️⃣ STRATEGY
   • What signals will you follow?
   • Example: RSI + Support/Resistance

4️⃣ RISK RULES
   • Max risk per trade: ____%
   • Max trades per day: ____
   • Max daily loss: ____%

5️⃣ ENTRY CHECKLIST
   □ Trend confirmed
   □ 2+ indicators agree
   □ Risk:Reward ≥ 1:2
   □ No major news soon

6️⃣ EXIT RULES
   • Take profit at: ____
   • Move SL to BE at: ____
   • Trail stop method: ____

7️⃣ TRADING HOURS
   • When will you trade?
   • Example: London-NY overlap only

8️⃣ REVIEW SCHEDULE
   • Daily: Review trades
   • Weekly: Analyze performance
   • Monthly: Adjust strategy`,
      ar: `📋 نموذج خطة التداول:

1️⃣ الأسواق
   • أي أزواج/أصول ستتداولها؟
   • مثال: EUR/USD، الذهب، البيتكوين فقط

2️⃣ الأطر الزمنية
   • أي أطر للتحليل؟
   • مثال: 4 ساعات للاتجاه، ساعة للدخول

3️⃣ الاستراتيجية
   • أي إشارات ستتبعها؟
   • مثال: RSI + الدعم/المقاومة

4️⃣ قواعد المخاطرة
   • أقصى مخاطرة لكل صفقة: ____%
   • أقصى صفقات في اليوم: ____
   • أقصى خسارة يومية: ____%

5️⃣ قائمة تحقق الدخول
   □ الاتجاه مؤكد
   □ 2+ مؤشرات متفقة
   □ المخاطرة:العائد ≥ 1:2
   □ لا أخبار مهمة قريبة

6️⃣ قواعد الخروج
   • جني الربح عند: ____
   • حرك SL للتعادل عند: ____
   • طريقة التتبع: ____

7️⃣ ساعات التداول
   • متى ستتداول؟
   • مثال: تداخل لندن-نيويورك فقط

8️⃣ جدول المراجعة
   • يومياً: راجع الصفقات
   • أسبوعياً: حلل الأداء
   • شهرياً: عدّل الاستراتيجية`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "checklist"
  },
  {
    id: 18,
    category: { en: "Trading Psychology", ar: "سيكولوجية التداول" },
    question: {
      en: "What is a TRADING JOURNAL and why you MUST have one?",
      ar: "ما هو دفتر التداول ولماذا يجب أن يكون لديك واحد؟"
    },
    answer: {
      en: `📓 TRADING JOURNAL - Your Secret Weapon:

WHY IT'S ESSENTIAL:
━━━━━━━━━━━━━━━━━━━━━━
• Identify your mistakes
• Find what works for YOU
• Track your progress
• Control emotions
• Become consistent

WHAT TO RECORD:
━━━━━━━━━━━━━━━━━━━━━━
📌 BEFORE TRADE:
• Date & time
• Pair/asset
• Setup type
• Entry reason
• Entry, SL, TP levels
• Risk amount

📌 AFTER TRADE:
• Result (pips, $)
• Screenshot
• What went right?
• What went wrong?
• Emotions during trade
• Lessons learned

━━━━━━━━━━━━━━━━━━━━━━
WEEKLY REVIEW:
━━━━━━━━━━━━━━━━━━━━━━
• Win rate %
• Average win vs loss
• Best performing setup
• Worst performing setup
• Emotional patterns
• Action items for next week`,
      ar: `📓 دفتر التداول - سلاحك السري:

لماذا هو ضروري:
━━━━━━━━━━━━━━━━━━━━━━
• حدد أخطاءك
• اكتشف ما يعمل لك
• تتبع تقدمك
• تحكم بالعواطف
• كن مستمراً

ماذا تسجّل:
━━━━━━━━━━━━━━━━━━━━━━
📌 قبل الصفقة:
• التاريخ والوقت
• الزوج/الأصل
• نوع الإعداد
• سبب الدخول
• مستويات الدخول، SL، TP
• مبلغ المخاطرة

📌 بعد الصفقة:
• النتيجة (نقاط، $)
• لقطة شاشة
• ما الذي سار جيداً؟
• ما الذي أخطأ؟
• المشاعر خلال الصفقة
• الدروس المستفادة

━━━━━━━━━━━━━━━━━━━━━━
المراجعة الأسبوعية:
━━━━━━━━━━━━━━━━━━━━━━
• نسبة النجاح %
• متوسط الربح مقابل الخسارة
• أفضل إعداد أداءً
• أسوأ إعداد أداءً
• الأنماط العاطفية
• بنود العمل للأسبوع القادم`
    },
    difficulty: { en: "Beginner", ar: "مبتدئ" },
    icon: "journal"
  },
];

// Signal Methods for the dropdown
export const SIGNAL_METHODS = [
  { value: "combined", label: "Combined (All)", labelAr: "مجمع (الكل)" },
  { value: "rsi", label: "RSI", labelAr: "مؤشر القوة النسبية RSI" },
  { value: "macd", label: "MACD", labelAr: "مؤشر MACD" },
  { value: "bollinger", label: "Bollinger Bands", labelAr: "نطاقات بولينجر" },
  { value: "stochastic", label: "Stochastic", labelAr: "ستوكاستيك" },
  { value: "moving_averages", label: "Moving Averages", labelAr: "المتوسطات المتحركة" },
  { value: "adx", label: "ADX (Trend)", labelAr: "قوة الاتجاه ADX" },
  { value: "williams_r", label: "Williams %R", labelAr: "ويليامز %R" },
  { value: "support_resistance", label: "Support/Resistance", labelAr: "الدعوم والمقاومات" },
];
